<template>
  <div class="lang lang_fixed">
    <div id="ytWidget" style="display: none" />
    <div class="lang__link lang__link_select">
      <img
        class="lang__img lang__img_select"
        :src="getLangImage(activeLang)"
        :alt="activeLang"
      />
    </div>
    <div class="lang__list" data-lang-list>
      <a
        v-for="lang of langsToChoose"
        class="lang__link lang__link_sub"
        :key="`lang_${lang}`"
        @click="onChangeLang(lang)"
      >
        <img class="lang__img" :src="getLangImage(lang)" :alt="lang" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useCommonStore } from '@/stores/common'
import { metrikaEvents } from '../../services/metrika'

export default {
  name: 'PresentationTranslator',
  props: {
    translator: {
      type: Object,
      requred: true,
    },
  },
  computed: {
    ...mapState(useCommonStore, ['activeLang']),
    origin() {
      const url = new URL(location.href)
      return url.origin
    },
    langsToChoose() {
      return this.langs.filter((lang) => lang !== this.activeLang)
    },
    langs() {
      return this.translator.langs
    },
    defaultLang() {
      return this.translator.currentLang || 'ru'
    },
  },
  methods: {
    ...mapActions(useCommonStore, ['setActiveLang']),
    getLangImage(lang) {
      return `${this.origin}/images/flags/${lang}.png`
    },
    yaTranslateGetCode() {
      const featureStoredStateRaw = localStorage[this.localStorageCode]
      const userLang = this.getUserLang()
      try {
        const featureState = JSON.parse(featureStoredStateRaw)
        const currentLang = featureState?.lang || userLang
        return currentLang
      } catch {
        return userLang
      }
    },
    yaTranslateSetLang(lang) {
      localStorage.setItem(
        this.localStorageCode,
        JSON.stringify({
          lang,
          active: true,
        }),
      )
    },
    onChangeLang(lang) {
      metrikaEvents.onChangeLanguage(this.yaTranslateGetCode(), lang)
      this.yaTranslateSetLang(lang)
      window.location.reload()
    },
    makeYTScriptLink() {
      const endpoint =
        'https://translate.yandex.net/website-widget/v1/widget.js'
      const url = new URL(endpoint)
      const params = {
        widgetId: 'ytWidget',
        pageLang: this.defaultLang,
        widgetTheme: 'light',
        autoMode: false,
      }
      Object.entries(params).forEach((param) => {
        url.searchParams.append(...param)
      })
      return url.toString()
    },
    getUserLang() {
      const currentUrl = new URL(location.href)
      return (
        currentUrl.searchParams.get('lang') ||
        this.langs?.[0] ||
        this.defaultLang
      )
    },
  },
  mounted() {
    this.langFirstVisit = this.getUserLang()
    if (this.langFirstVisit && !localStorage.getItem(this.localStorageCode)) {
      this.yaTranslateSetLang(this.langFirstVisit)
    }

    const script = document.createElement('script')
    script.src = this.makeYTScriptLink()
    document.getElementsByTagName('head')[0].appendChild(script)

    this.setActiveLang(this.yaTranslateGetCode())
  },
  data() {
    return {
      localStorageCode: 'yt-widget',
      langFirstVisit: 'ru',
    }
  },
}
</script>

<style scoped>
.lang {
  position: relative;
  z-index: 10;
  text-align: center;
  background: rgba(157, 157, 157, 0.3);
  perspective: 700px;
}

.lang_fixed {
  position: fixed;
  right: 20px;
  top: 20px;
}

.lang__link {
  cursor: pointer;
  transition: 0.3s all;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-shrink: 0;
  box-sizing: border-box;
  text-decoration: none;
  border-radius: 2px;
  padding: 4px;
}

.lang__img {
  width: 30px;
  height: 26px;
  flex-shrink: 0;
  font-size: 10px;
  display: block;
  transition: 0.3s all;
}

.lang__link_sub:hover {
  filter: drop-shadow(0 0 3px rgb(136, 136, 136)) brightness(130%);
}

.lang__name {
  color: #737b84;
  font-size: 12px;
  line-height: 12px;
  flex-shrink: 0;
  text-transform: uppercase;
}

.lang__link_sub {
  width: 100%;
  height: auto;
  position: relative;
  padding: 0;
  margin-bottom: 2px;
}

.lang__list {
  background: rgba(157, 157, 157, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s all;
  transform: rotateX(-90deg);
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 10;
  line-height: 13px;
  padding: 4px;
  transform-origin: center top;
  box-sizing: border-box;
}

.lang:hover .lang__list {
  opacity: 1;
  visibility: visible;
  transform: rotateX(0);
}

.lang__link_select {
  align-items: flex-start;
  text-align: center;
  font-size: 0;
}
</style>
